import type { APIApplicationFile } from 'types/api.types';
import { useApplicationFiles } from 'views/shared/hooks/useApplicationFiles';

export const useBaraFiles = (
  uuid: string,
  isOpen: boolean,
  initialFiles?: APIApplicationFile[],
) => {
  const {
    files,
    isUploadingFile,
    deletingFileId,
    handleFilesUpload,
    handleFileRemove,
    resetFiles,
  } = useApplicationFiles(uuid, 'bara', { isOpen, initialFiles });

  return {
    baraFiles: files,
    isUploadingFile,
    deletingFileId,
    handleFilesUpload,
    handleFileRemove,
    resetFiles,
  };
};
